var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowReadStatus)?_c('div',{class:{
    'message-label': true,
    'unread': _vm.isUseUnreadStyle,
    'finger-point': _vm.isHoverFingerPointer,
  },on:{"click":_vm.openReadUserPanel}},[_c('span',[_vm._v(_vm._s(_vm.readStatusText))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }